import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import * as S from './index.style'

import { FileUpload } from '@styled-icons/material-outlined/FileUpload'
import Divider from '@material-ui/core/Divider'
import { CasasSimplificado } from 'models/Viabilidade/CasasSimplificado'
import NumberFormat from 'react-number-format'
import { Guid } from 'guid-typescript'
import { format } from 'date-fns'
import { RetornoApiGenerics } from 'models/Geral/RetornoApiGenerics'

import { downloadViabilidadeCasas, excluirViabilidadeCasas } from 'services/viabilidadeCasas.service'
import { useSnackbar } from 'components/SnackBar'
import Loading from 'components/Loading'
import ModalClonarViabilidade from '../../ModalClonarViabilidade'
import { PdfDto } from 'models/Viabilidade/PdfDto'

import React from 'react'
import { parsePorcentagem } from 'helpers/formatador'
import { ContentCopy } from '@styled-icons/material-outlined/ContentCopy'
import { Edit } from '@styled-icons/material-rounded/Edit'
import { Delete } from '@styled-icons/material-rounded'
import { TipoSituacaoEnum } from 'models/Viabilidade/Enum/TipoSituacaoEnum'
import { EstadoModalEnum } from 'models/Viabilidade/Enum/EstadoModalEnum'
import { ConfirmModal } from 'components/ConfirmModal'

const CartaoViabilidade: React.FC<{
  nomeTerreno: string | undefined
  areaTerreno: number | undefined
  dataCompraTerreno: string | undefined
  token: string | null
  dados: CasasSimplificado
  fase: number
  idEmpreendimento?: string | null

  onClickViabilidadeHandler: (idViabilidade: Guid, situacaoViabilidade: number) => void
}> = ({ dados, onClickViabilidadeHandler, nomeTerreno, areaTerreno, dataCompraTerreno, token, fase, idEmpreendimento }) => {
  const onClickCardHandler = () => {
    onClickViabilidadeHandler(dados.id, dados.situacao)
  }
  const localDate = new Date(dados.atualizadoEm)
  const snackBar = useSnackbar()
  const [loading, setLoading] = React.useState(false)
  const [mostrarModalClonar, setMostrarModalClonar] = React.useState(false)
  const [estadoModalExcluir, setEstadoModalExcluir] = React.useState(EstadoModalEnum.Fechado)

  const baixarViabilidade = (base64: string) => {
    const linkSource = `data:application/pdf;base64,${base64}`
    const filename = `${dados?.nomeViabilidade}.pdf`
    downloadArquivo(linkSource, filename)
  }
  const downloadArquivo = (linkSource: string, filename: string) => {
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = filename
    downloadLink.click()
  }

  const exportarViabilidade = async () => {
    setLoading(true)
    snackBar.showInfo('Processando os dados...')
    await downloadViabilidadeCasas(dados?.id).then((respostaApi: RetornoApiGenerics<PdfDto>) => {
      if (respostaApi.entity?.base64) {
        baixarViabilidade(respostaApi.entity.base64)
        snackBar.showSuccess('Viabilidade exportada com sucesso!')
      } else {
        snackBar.showError('Não foi possível realizar sua solicitação. Tente novamente mais tarde.')
      }
      setLoading(false)
    })
  }

  const abrirModalClonarViabilidade = () => {
    if (mostrarModalClonar) {
      setMostrarModalClonar(false)
    } else {
      setMostrarModalClonar(true)
    }
  }

  const onClickEditarViabilidade = () => {
    onClickViabilidadeHandler(dados.id, TipoSituacaoEnum.Rascunho)
  }

  const fecharModalClonarViabilidade = () => {
    setMostrarModalClonar(false)
  }

  const cabecalhoViabilidade = () => {
    return (
      <>
        {dados.situacao === TipoSituacaoEnum.Rascunho ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonRascunho />
            <S.TituloCabecalhoRascunho data-cy="tituloCabecalho">Rascunho</S.TituloCabecalhoRascunho>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.EmAnalise ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonEmAnalise />
            <S.TituloCabecalhoEmAnalise data-cy="tituloCabecalho">
              <S.IconEmAnalise />
              Em Análise
            </S.TituloCabecalhoEmAnalise>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Aprovado ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonAprovado />
            <S.TituloCabecalhoAprovado data-cy="tituloCabecalho">
              <S.IconAprovado />
              Aprovado
            </S.TituloCabecalhoAprovado>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Reprovado ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonReprovado />
            <S.TituloCabecalhoReprovado data-cy="tituloCabecalho">
              <S.IconReprovado />
              Reprovado
            </S.TituloCabecalhoReprovado>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Simulado ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonSimulado />
            <S.TituloCabecalhoSimulado data-cy="tituloCabecalho">
              <S.IconSimulado />
              Simulado
            </S.TituloCabecalhoSimulado>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Vigente ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonVigente />
            <S.TituloCabecalhoVigente data-cy="tituloCabecalho">
              <S.IconVigente />
              Vigente
            </S.TituloCabecalhoVigente>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Oficial ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonOficial />
            <S.TituloCabecalhoOficial data-cy="tituloCabecalho">
              <S.IconOficial />
              Oficial
            </S.TituloCabecalhoOficial>
          </S.CabecalhoCard>
        ) : dados.situacao === TipoSituacaoEnum.Descartado ? (
          <S.CabecalhoCard>
            <S.CabecalhoRibbonDescartado />
            <S.TituloCabecalhoDescartado data-cy="tituloCabecalho">
              <S.IconDescartado />
              Descartado
            </S.TituloCabecalhoDescartado>
          </S.CabecalhoCard>
        ) : (
          <></>
        )}
      </>
    )
  }

  const abrirModalExcluirViabilidade = () => {
    setEstadoModalExcluir(EstadoModalEnum.Confirmacao)
  }

  const fecharModalExcluirViabilidade = () => {
    setEstadoModalExcluir(EstadoModalEnum.Fechado)
  }

  const confirmarModalExcluirViabilidade = (idTerreno: Guid) => {
    setEstadoModalExcluir(EstadoModalEnum.Loading)
    excluirViabilidadeCasas(idTerreno)
      .then((respostaApi) => {
        if (respostaApi) {
          setEstadoModalExcluir(EstadoModalEnum.Sucesso)
        } else {
          setEstadoModalExcluir(EstadoModalEnum.Erro)
        }
      })
      .catch(() => {
        setEstadoModalExcluir(EstadoModalEnum.Erro)
      })
  }

  const concluirModalExcluirViabilidade = () => {
    history.go(0)
  }

  return (
    <S.CardViabilidade>
      <CardActionArea onClick={onClickCardHandler}>
        {cabecalhoViabilidade()}
        <CardContent>
          <S.NomeViabilidade data-cy="nomeViabilidade">{dados.nomeViabilidade}</S.NomeViabilidade>
          <S.DataViabilidadeNomeUsuario data-cy="dataViabilidadeNomeUsuario">{`${format(localDate, 'dd/MM/yyyy')} - ${
            dados.atualizadoPor
          }`}</S.DataViabilidadeNomeUsuario>
          <Divider orientation="horizontal" color="#D9DDDB" />
          <S.GridCampos>
            <S.Campos>
              <S.Label data-cy="campoMargemBruta">Margem Bruta (%)</S.Label>
              <S.Valor data-cy="valorMargemBruta">
                <NumberFormat
                  value={parsePorcentagem(dados.margemBruta as string)}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoTotalUnidades">Número Unidades</S.Label>
              <S.Valor data-cy="valorTotalUnidades">
                <NumberFormat
                  value={dados.totalUnidades}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoCustoCasa">Custo (R$/Unid)</S.Label>
              <S.Valor data-cy="valorCustoCasa">
                <NumberFormat
                  value={dados.custoCasa}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoPrecoMediaCasasUnidade">Preço Venda Médio (R$)</S.Label>
              <S.Valor data-cy="valorPrecoMedioCasasUnidade">
                <NumberFormat
                  value={dados.precoMedioCasasUnidade}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoIndiceDuration">Duration</S.Label>
              <S.Valor data-cy="valorIndiceDuration">
                <NumberFormat
                  value={dados.indiceDuration}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoFracaoContabil">Fração Contábil</S.Label>
              <S.Valor data-cy="valorFracaoContabil">
                <NumberFormat
                  value={dados.fracaoContabil}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="campoUrbanizacaoTotal">Urbanização</S.Label>
              <S.Valor data-cy="valorUrbanizacaoTotal">
                <NumberFormat
                  value={dados.urbanizacaoValorTotal}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
          </S.GridCampos>
        </CardContent>
      </CardActionArea>
      <S.CardActionsCustomizado>
        <S.BoxCustomizada>
          <S.IconButtonCustomizado data-cy="btnClonar" onClick={abrirModalClonarViabilidade}>
            <ContentCopy size={20} />
          </S.IconButtonCustomizado>
          <S.IconButtonCustomizado data-cy="btnExcluir" onClick={abrirModalExcluirViabilidade}>
            <Delete size={20} />
          </S.IconButtonCustomizado>
          {mostrarModalClonar ? (
            <ModalClonarViabilidade
              idViabilidade={dados?.id.toString()}
              situacaoViabilidade={dados?.situacao}
              aberto={mostrarModalClonar}
              closeDialogClonarViabilidade={fecharModalClonarViabilidade}
              nomeTerreno={nomeTerreno}
              areaTerreno={areaTerreno}
              dataCompraTerreno={dataCompraTerreno}
              token={token}
              fase={fase}
              idEmpreendimento={idEmpreendimento}
            />
          ) : (
            estadoModalExcluir != EstadoModalEnum.Fechado && (
              <ConfirmModal
                funcaoConfirmar={() => {
                  confirmarModalExcluirViabilidade(dados?.id)
                }}
                funcaoCancelar={fecharModalExcluirViabilidade}
                funcaoOk={concluirModalExcluirViabilidade}
                estadoModal={estadoModalExcluir}
                titulo={''}
                botaoConfirmacao={'Sim'}
                botaoCancelar={'Não'}
                textoSucesso={'A viabilidade foi excluída com sucesso.'}
                textoErro={'Ocorreu um erro ao excluir essa viabilidade.'}
              >
                <S.IconModalExcluir />
                <S.Linha />
                <S.TextoModalExcluir>Deseja mesmo excluir essa viabilidade?</S.TextoModalExcluir>
              </ConfirmModal>
            )
          )}
          {dados.situacao != TipoSituacaoEnum.Aprovado && (
            <div>
              <S.IconButtonCustomizado data-cy="btnEditar" onClick={onClickEditarViabilidade}>
                <Edit size={20} />
              </S.IconButtonCustomizado>
            </div>
          )}
          <S.ButtonCustomizado
            data-cy="btnExportar"
            variant="outlined"
            color="secondary"
            startIcon={<FileUpload size={20} />}
            disabled={loading}
            onClick={(event) => {
              event.stopPropagation()
              exportarViabilidade()
            }}
          >
            Exportar
          </S.ButtonCustomizado>
          {loading && <Loading />}
        </S.BoxCustomizada>
      </S.CardActionsCustomizado>
    </S.CardViabilidade>
  )
}

export default CartaoViabilidade
